import { xmlToJson } from './xmlUtils';

const DaliTypes = {
  STILL: 'image',
  MOVIE: 'video'
};

// eslint-disable-next-line
export const parseDaliXml = xml => {
  try {
    const daliObj = xmlToJson(xml);
    return {
      dataSrc: 'dali',
      guid: daliObj.PROXIMITYCHYRONSTILL.GUID[0],
      title: daliObj.PROXIMITYCHYRONSTILL.TITLE[0],
      type: DaliTypes[daliObj.PROXIMITYCHYRONSTILL.TYPE[0]]
    };
  } catch (e) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./app/util/daliUtils.js